<template>
  <v-layout align-center justify-center row fill-height>
    <div style="text-align: center">
      <!-- <h1 style="font-weight: bold;" class="display-4">404</h1> -->
      <h6 class="title">{{ $t('views.browserNotSupported.message') }}</h6>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'BrowserNotSupported',
}
</script>
